import { Input, Form, Divider, Select, Radio, Button, Typography } from 'antd'
import React, { useState, useEffect }from 'react'
import PhoneNumberFormatter from "../../utils/PhoneNumberFormatter";
import PostalCodeFormatter from "../../utils/PostalCodeFormatter";
import { apiCall } from '../../utils/Api';

const CreateNewAccount = (props) => {
    const [form] = Form.useForm();
    const createAccount = props.createAccount;

    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState("Canada");
    const [provinces, setProvinces] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState();

    const listCountries = () => {
        apiCall("country/getList", {}, (_s, _r) => {
            if (_s) {
                setCountries(_r);
            }
        }, "customer")
    }

    const listProvinces = (_country) => {

        if (!_country) {
            _country = selectedCountry;
        }

        apiCall("province/getList", { "country": _country }, (_s, _r) => {
            if (_s) {
                setProvinces(_r)
            }
        }, "customer")
    }

    useEffect(listCountries, []);
    useEffect(listProvinces, [selectedCountry]);

    const postalError = () => {
        let ret = "Valid postal code is required.";
        if (selectedCountry === "Canada") {
            return ret + " eg. A1B 2C3"
        }

        if (selectedCountry === "United States") {
            return ret + " eg. 12345 or 12345-6789"
        }

        return ret;
    }

    const displayConfirmPassword = () => {
        return (
            <>
                <Form.Item
                    name="password"
                    label="Password"
                    rules={[{
                        required: true,
                        min: 8,
                        message: 'Password must be at least 8 characters.',
                    },]}
                    hasFeedback
                    initialValue=""
                >
                    <Input.Password autoComplete="new-password" aria-label="Password" placeholder="Password" />
                </Form.Item>

                <Form.Item
                    name="confirm"
                    label="Confirm password"
                    dependencies={['password']}
                    hasFeedback
                    rules={[{
                        required: true,
                        message: 'Please confirm your password.',
                    }, ({ getFieldValue }) => ({
                        validator(rule, value) {

                            if (value.length < 8) {
                                return Promise.reject('Password must be at least 8 characters.');
                            }

                            if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject('The two passwords that you entered do not match.');
                        },
                    }),]}
                >
                    <Input.Password aria-label="Confirm Password" placeholder="Confirm password" min={8} max={12} />
                </Form.Item>
            </>
        )

    }

    return (
        <div style={{ "padding": "20px" }}>
            <Typography.Title level={5}>Create new account</Typography.Title>


            <Form
                style={{  margin: "0 auto" }}
                layout="vertical"
                onFinish={(_form) => createAccount(_form, props.close)}
                form={form} 
            >
                <div style={{ display: "flex", justifyContent: "space-evenly"}}>
                    <div style={{width: '334px'}}>
                        <Form.Item initialValue="" label="Email address" name="user" rules={[{ message: "Email address is required.", required: true }]}>
                                <Input aria-label="Email address" maxLength={80} />
                        </Form.Item>

                        {displayConfirmPassword()}

                        <Form.Item label="First name" name="first_name" rules={[{ message: "First name is required.", required: true }]}>
                            <Input placeholder="First name" aria-label="First name" maxLength={80} />
                        </Form.Item>

                        <Form.Item label="Last name" name="last_name" rules={[{ message: "Last name is required.", required: true }]}>
                            <Input placeholder="Last name" aria-label="Last name" maxLength={80} />
                        </Form.Item>

                        <Form.Item label="Street address" name="street_address" rules={[{ message: "Street address is required.", required: true }]}>
                            <Input placeholder="Street address" aria-label="Street address" maxLength={80} />
                        </Form.Item>


                        <Form.Item label="Street address (line 2)" initialValue="" name="street_address_2">
                            <Input placeholder="Street address (line 2)" aria-label="Street address (line 2)" maxLength={80} />
                        </Form.Item>
                        <Form.Item label="City" name="city" rules={[{ message: "City is required.", required: true }]}>
                            <Input aria-label="City" maxLength={80} />
                        </Form.Item>
                    </div>
                    <div >
                        <Form.Item label="Country" name="country" initialValue={selectedCountry} rules={[{ message: "Country is required.", required: true }]}>
                            <Select aria-label="Select country" showSearch placeholder="Select country" style={{ maxWidth: 400 }} onChange={(v) => setSelectedCountry(v)}>
                                {countries.map((item, index) => {
                                    return (<Select.Option key={index} value={item}>{item}</Select.Option>)
                                })}
                            </Select>
                        </Form.Item>

                        {((provinces.length > 0) && (selectedCountry) && <Form.Item label="State / Province" name="province" rules={[{ validateTrigger: "onBlur", validator: (_, value) => (provinces.includes(selectedProvince)) ? Promise.resolve() : (provinces.length > 0) ? Promise.reject("no") : Promise.resolve(), message: "Valid state / province is required.", required: true }]}>
                            <Select aria-label="Select state / province" showSearch placeholder="Select state / province" onChange={(v) => setSelectedProvince(v)} style={{ maxWidth: 400 }}>
                                {provinces.map((item, index) => {
                                    return (<Select.Option key={index} value={item}>{item}</Select.Option>)
                                })}
                            </Select>
                        </Form.Item>)}

                        {((!provinces.length > 0) && (selectedCountry) && <Form.Item label="State / Province" name="province" rules={[{ validateTrigger: "onBlur", validator: (_, value) => (provinces.includes(selectedProvince)) ? Promise.resolve() : (provinces.length > 0) ? Promise.reject("no") : Promise.resolve(), message: "Valid state / province is required.", required: false }]}>
                            <Input aria-label="Select state / province" placeholder="Select state / province" style={{ maxWidth: 400 }} maxLength={80} />
                        </Form.Item>)}


                        <Form.Item rules={[{ required: true }]} label={<><div style={{ "fontFamily": "SimSun, sans-serif", "color": "#ff4d4f" }}>*</div>&nbsp;Phone number</>}>
                            <Input.Group compact>

                                <Form.Item noStyle name="phone_number" rules={[{ message: "Required. Must be a phone number.", pattern: new RegExp(/^[0-9+. \-)(]{10,15}$/g), required: true }]}>
                                    <PhoneNumberFormatter field="phone_number" form={form} country={selectedCountry} style={{ width: "156px" }} inputMode="numeric" placeholder="Phone number" />                        
                                </Form.Item>

                                <Form.Item noStyle initialValue="" name="phone_number_ext" rules={[{ message: "Must be between 2 and 6 digits", pattern: new RegExp(/^[0-9]{2,6}$/g), required: false }]}>
                                    <Input aria-label="Alternate phone number extension" field="phone_number_ext" style={{ width: '80px' }} maxLength={6} inputMode="numeric" placeholder="Ext." />
                                </Form.Item>

                                <Form.Item noStyle initialValue="cell" name="phone_number_type" rules={[{ required: true }]}>
                                    <Select aria-label="Select phone number type" virtual={false} style={{ width: '100px' }} >
                                        <Select.Option value="cell">Cell</Select.Option>
                                        <Select.Option value="home">Home</Select.Option>
                                        <Select.Option value="work">Work</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Input.Group>
                        </Form.Item>

                        <Form.Item rules={[{ required: true }]} label="Alternate phone number">
                            <Input.Group compact>
                                <Form.Item noStyle initialValue="" rules={[{ message: "Must be a phone number", pattern: new RegExp(/^[0-9+. \-)(]{10,15}$/g) }]} name="alt_phone_number" >
                                    <PhoneNumberFormatter field="alt_phone_number" form={form} country={selectedCountry} style={{ width: "156px" }} inputMode="numeric" placeholder="Phone number" />
                                </Form.Item>
                                
                                <Form.Item noStyle initialValue="" name="alt_phone_number_ext" rules={[{ message: "Must be between 2 and 6 digits", pattern: new RegExp(/^[0-9]{2,6}$/g), required: false }]}>
                                    <Input  aria-label="Alternate phone number extension" field="aext" style={{ width: '80px' }} maxLength={6} inputMode="numeric" placeholder="Ext." />
                                </Form.Item>

                                <Form.Item noStyle initialValue="home" name="alt_phone_number_type">
                                    <Select aria-label="Select alternate phone number type" virtual={false} style={{ width: '100px' }} >
                                        <Select.Option value="home">Home</Select.Option>
                                        <Select.Option value="cell">Cell</Select.Option>
                                        <Select.Option value="work">Work</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Input.Group>
                        </Form.Item>

                        <Form.Item label="Company" name="company" rules={[{ message: "Company is required.", required: true }]}>
                            <Input aria-label="Company" maxLength={80} />
                        </Form.Item>

                        <Form.Item
                            label="Role at Company"
                            name="role"
                            rules={[
                                { required: true, message: "Role is required." },
                                { max: 250, message: "Role cannot exceed 250 characters." },
                            ]}
                        >
                            <Input.TextArea aria-label="Role" maxLength={250} />
                        </Form.Item>

                        <Form.Item initialValue="email" label="Preferred method of communication" name="communication_prefence" rules={[{ required: true }]}>
                            <Radio.Group buttonStyle="solid">
                                <Radio.Button value="email">Email</Radio.Button>
                                <Radio.Button value="phone">Phone</Radio.Button>
                                <Radio.Button value="text">Text</Radio.Button>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item label={(selectedCountry === "United States") ? "Zip code" : "Postal code"} name="postal_code" rules={[{ pattern: (selectedCountry === "Canada") ? new RegExp(/^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/) : (selectedCountry === "United States") ? new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/) : "", message: postalError(), required: true }]}>
                            <PostalCodeFormatter form={form} country={selectedCountry} />
                        </Form.Item>

                        <div style={{display: "flex", justifyContent: "end"}}>
                            <Button type="primary" htmlType="submit">Create Account</Button>
                        </div>
                    </div>
                </div>
                


                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
            </Form>

        </div>
    )
}

export default CreateNewAccount